import React from "react";
import styled from "styled-components";
import { Barlow, White } from "../Common";

const Container = styled.footer`
  height: auto;
  width: 100%;
  background-color: #90d4c6;
  /* max-height: 350px; */
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 57px 0;
  @media screen and (max-width: 992px) {
  }
`;
const Content = styled.div`
  height: auto;
  width: auto;
`;
const Logo = styled.div`
  height: auto;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 40px;
  & svg {
    height: 33px;
    width: 170px;
  }
`;
const Links = styled.div`
  height: auto;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 88px;

  & ul {
    display: flex;
    align-items: center;
    flex-direction: row;
    column-gap: 57px;
    @media screen and (max-width: 576px) {
      column-gap: 30px;
    }

    li {
      font-family: ${Barlow};
      font-style: normal;
      font-weight: 600;
      font-size: 18px;
      line-height: 25px;
      letter-spacing: -0.128571px;
      color: #458d7e;
      cursor: pointer;
      transition: all 0.2s ease-in-out;

      &:hover {
        color: ${White};
      }
    }
  }
`;
const Socials = styled.div`
  height: auto;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  & ul {
    display: flex;
    align-items: center;
    flex-direction: row;
    column-gap: 28px;
    & li {
      cursor: pointer;
      & svg path {
        transition: all 0.2s ease-in-out;
      }
      &:hover svg > path {
        fill: ${White};
      }
    }
  }
`;

function Footer() {
  return (
    <Container>
      <Content>
        <Logo>
          <svg
            viewBox="0 0 170 33"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M121.588 6.28571C122.839 6.28571 123.806 5.98965 124.489 5.39752C125.171 4.80538 125.512 4.05383 125.512 3.14286C125.512 2.20911 125.182 1.45186 124.523 0.871118C123.863 0.290373 122.885 0 121.588 0C120.291 0 119.313 0.290373 118.653 0.871118C117.994 1.45186 117.664 2.20911 117.664 3.14286C117.664 4.05383 118.005 4.80538 118.688 5.39752C119.37 5.98965 120.337 6.28571 121.588 6.28571ZM13.6495 24.2376C12.1708 25.2283 10.3054 25.7236 8.05322 25.7236C3.32139 25.7236 0.636978 23.7992 0 19.9503L5.11857 18.7888C5.43706 20.2464 6.41528 20.9752 8.05322 20.9752C9.16793 20.9752 9.72529 20.6791 9.72529 20.087C9.72529 19.882 9.65135 19.7169 9.50348 19.5916C9.35561 19.4664 9.03144 19.3126 8.53096 19.1304L6.48353 18.3789L5.90342 18.1739C5.49394 18.0373 5.16976 17.9177 4.93089 17.8152C4.69203 17.7127 4.3451 17.5476 3.89012 17.3199C3.43513 17.0921 3.05977 16.8473 2.76403 16.5854C2.46829 16.3235 2.16118 16.016 1.84269 15.663C1.5242 15.31 1.28533 14.9001 1.12609 14.4332C0.966842 13.9664 0.887219 13.4596 0.887219 12.913C0.887219 11.1594 1.58107 9.73602 2.96877 8.64286C4.35647 7.54969 6.09679 7.00311 8.18972 7.00311C11.6931 7.00311 14.059 8.52899 15.2875 11.5807L10.203 13.0155C9.74804 12.059 9.05419 11.5807 8.12147 11.5807C7.37075 11.5807 6.99538 11.8654 6.99538 12.4348C6.99538 12.6398 7.08638 12.8106 7.26837 12.9472C7.45037 13.0839 7.75748 13.2205 8.18972 13.3571L10.1689 14.177C13.8543 15.4524 15.7538 17.3654 15.8676 19.9161C15.8676 21.8064 15.1282 23.2469 13.6495 24.2376ZM29.0345 23.1273C27.9653 24.8582 26.3046 25.7236 24.0524 25.7236C19.8893 25.7236 17.8078 23.1159 17.8078 17.9006V7.37888H24.8373V17.2174C24.8373 19.2443 25.5425 20.2578 26.9529 20.2578C28.3406 20.2578 29.0345 19.2443 29.0345 17.2174V7.37888H36.064V25.3478H29.0345V23.1273ZM46.1939 25.3478V15.5093C46.1939 13.4824 46.8878 12.4689 48.2755 12.4689C49.6859 12.4689 50.3911 13.4824 50.3911 15.5093V25.3478H57.4206V14.8261C57.4206 9.61077 55.3391 7.00311 51.176 7.00311C48.9238 7.00311 47.2631 7.86853 46.1939 9.59938V7.37888H39.1644V25.3478H46.1939ZM67.3458 15.5093V25.3478H60.3163V7.37888H67.3458V9.59938C68.415 7.86853 70.0757 7.00311 72.3279 7.00311C76.491 7.00311 78.5725 9.61077 78.5725 14.8261V25.3478H71.543V15.5093C71.543 13.4824 70.8378 12.4689 69.4274 12.4689C68.0396 12.4689 67.3458 13.4824 67.3458 15.5093ZM89.3167 33L100.714 7.37888H93.3774L89.8968 16.5683L86.7915 7.37888H79.1136L86.5868 23.6056L82.4237 33H89.3167ZM113.71 24.2376C112.232 25.2283 110.366 25.7236 108.114 25.7236C103.382 25.7236 100.698 23.7992 100.061 19.9503L105.179 18.7888C105.498 20.2464 106.476 20.9752 108.114 20.9752C109.229 20.9752 109.786 20.6791 109.786 20.087C109.786 19.882 109.712 19.7169 109.564 19.5916C109.416 19.4664 109.092 19.3126 108.592 19.1304L106.544 18.3789L105.964 18.1739C105.555 18.0373 105.231 17.9177 104.992 17.8152C104.753 17.7127 104.406 17.5476 103.951 17.3199C103.496 17.0921 103.121 16.8473 102.825 16.5854C102.529 16.3235 102.222 16.016 101.903 15.663C101.585 15.31 101.346 14.9001 101.187 14.4332C101.028 13.9664 100.948 13.4596 100.948 12.913C100.948 11.1594 101.642 9.73602 103.03 8.64286C104.417 7.54969 106.158 7.00311 108.251 7.00311C111.754 7.00311 114.12 8.52899 115.348 11.5807L110.264 13.0155C109.809 12.059 109.115 11.5807 108.182 11.5807C107.432 11.5807 107.056 11.8654 107.056 12.4348C107.056 12.6398 107.147 12.8106 107.329 12.9472C107.511 13.0839 107.818 13.2205 108.251 13.3571L110.23 14.177C113.915 15.4524 115.815 17.3654 115.928 19.9161C115.928 21.8064 115.189 23.2469 113.71 24.2376ZM125.103 7.37888V25.3478H118.073V7.37888H125.103ZM135.745 25.7236C138.133 25.7236 139.839 24.8582 140.863 23.1273V25.3478H147.893V0.649068H140.863V9.63354C139.839 7.87992 138.133 7.00311 135.745 7.00311C133.333 7.00311 131.326 7.88561 129.722 9.65062C128.118 11.4156 127.316 13.6532 127.316 16.3634C127.316 19.0735 128.118 21.3111 129.722 23.0761C131.326 24.8411 133.333 25.7236 135.745 25.7236ZM135.25 19.2329C135.853 19.9845 136.655 20.3602 137.656 20.3602C138.656 20.3602 139.458 19.9845 140.061 19.2329C140.664 18.4814 140.966 17.5248 140.966 16.3634C140.966 15.2019 140.664 14.2453 140.061 13.4938C139.458 12.7422 138.656 12.3665 137.656 12.3665C136.655 12.3665 135.847 12.7422 135.233 13.4938C134.641 14.2453 134.345 15.2019 134.345 16.3634C134.345 17.5248 134.647 18.4814 135.25 19.2329ZM160.616 25.7236C164.188 25.7236 166.974 24.6874 168.976 22.6149L166.076 18.7205C164.643 19.882 163.027 20.4627 161.23 20.4627C159.865 20.4627 158.756 20.1553 157.903 19.5404C157.05 18.9255 156.623 18.3333 156.623 17.764H169.829C169.943 17.354 170 16.8188 170 16.1584C170 13.3344 169.073 11.1025 167.219 9.46273C165.365 7.82298 162.993 7.00311 160.104 7.00311C157.01 7.00311 154.565 7.92547 152.767 9.77019C150.97 11.6149 150.072 13.8354 150.072 16.4317C150.072 19.0963 151.021 21.3111 152.921 23.0761C154.821 24.8411 157.386 25.7236 160.616 25.7236ZM157.715 12.5885C157.033 13.0326 156.669 13.676 156.623 14.5186H163.653C163.607 13.6988 163.243 13.0611 162.561 12.6056C161.879 12.1501 161.071 11.9224 160.138 11.9224C159.205 11.9224 158.398 12.1444 157.715 12.5885Z"
              fill="#2C7566"
            />
          </svg>
        </Logo>
        <Links>
          <ul>
            <li>About</li>
            <li>Services</li>
            <li>Projects</li>
          </ul>
        </Links>
        <Socials>
          <ul>
            <li className="facebook">
              <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M18.896 0H1.104C.494 0 0 .494 0 1.104v17.793C0 19.506.494 20 1.104 20h9.58v-7.745H8.076V9.237h2.606V7.01c0-2.583 1.578-3.99 3.883-3.99 1.104 0 2.052.082 2.329.119v2.7h-1.598c-1.254 0-1.496.597-1.496 1.47v1.928h2.989l-.39 3.018h-2.6V20h5.098c.608 0 1.102-.494 1.102-1.104V1.104C20 .494 19.506 0 18.896 0z"
                  fill="#2C7566"
                  fillRule="nonzero"
                />
              </svg>
            </li>
            <li className="instagram">
              <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M10 1.802c2.67 0 2.987.01 4.042.059 2.71.123 3.975 1.409 4.099 4.099.048 1.054.057 1.37.057 4.04 0 2.672-.01 2.988-.057 4.042-.124 2.687-1.387 3.975-4.1 4.099-1.054.048-1.37.058-4.041.058-2.67 0-2.987-.01-4.04-.058-2.718-.124-3.977-1.416-4.1-4.1-.048-1.054-.058-1.37-.058-4.041 0-2.67.01-2.986.058-4.04.124-2.69 1.387-3.977 4.1-4.1 1.054-.048 1.37-.058 4.04-.058zM10 0C7.284 0 6.944.012 5.877.06 2.246.227.227 2.242.061 5.877.01 6.944 0 7.284 0 10s.012 3.057.06 4.123c.167 3.632 2.182 5.65 5.817 5.817 1.067.048 1.407.06 4.123.06s3.057-.012 4.123-.06c3.629-.167 5.652-2.182 5.816-5.817.05-1.066.061-1.407.061-4.123s-.012-3.056-.06-4.122C19.777 2.249 17.76.228 14.124.06 13.057.01 12.716 0 10 0zm0 4.865a5.135 5.135 0 100 10.27 5.135 5.135 0 000-10.27zm0 8.468a3.333 3.333 0 110-6.666 3.333 3.333 0 010 6.666zm5.338-9.87a1.2 1.2 0 100 2.4 1.2 1.2 0 000-2.4z"
                  fill="#2C7566"
                  fillRule="nonzero"
                />
              </svg>
            </li>
            <li className="twitter">
              <svg width="20" height="17" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M20 2.172a8.192 8.192 0 01-2.357.646 4.11 4.11 0 001.805-2.27 8.22 8.22 0 01-2.606.996A4.096 4.096 0 0013.847.248c-2.65 0-4.596 2.472-3.998 5.037A11.648 11.648 0 011.392 1a4.109 4.109 0 001.27 5.478 4.086 4.086 0 01-1.858-.513c-.045 1.9 1.318 3.679 3.291 4.075a4.113 4.113 0 01-1.853.07 4.106 4.106 0 003.833 2.849A8.25 8.25 0 010 14.658a11.616 11.616 0 006.29 1.843c7.618 0 11.923-6.434 11.663-12.205A8.354 8.354 0 0020 2.172z"
                  fill="#2C7566"
                  fillRule="nonzero"
                />
              </svg>
            </li>
            <li className="pinterest">
              <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M10 0C4.477 0 0 4.477 0 10c0 4.237 2.636 7.855 6.356 9.312-.088-.791-.167-2.005.035-2.868.181-.78 1.172-4.97 1.172-4.97s-.299-.6-.299-1.486c0-1.39.806-2.428 1.81-2.428.852 0 1.264.64 1.264 1.408 0 .858-.546 2.14-.828 3.33-.236.995.5 1.807 1.48 1.807 1.778 0 3.144-1.874 3.144-4.58 0-2.393-1.72-4.068-4.176-4.068-2.845 0-4.516 2.135-4.516 4.34 0 .859.331 1.781.745 2.281a.3.3 0 01.069.288l-.278 1.133c-.044.183-.145.223-.335.134-1.249-.581-2.03-2.407-2.03-3.874 0-3.154 2.292-6.052 6.608-6.052 3.469 0 6.165 2.473 6.165 5.776 0 3.447-2.173 6.22-5.19 6.22-1.013 0-1.965-.525-2.291-1.148l-.623 2.378c-.226.869-.835 1.958-1.244 2.621.937.29 1.931.446 2.962.446 5.523 0 10-4.477 10-10S15.523 0 10 0z"
                  fill="#2C7566"
                  fillRule="nonzero"
                />
              </svg>
            </li>
          </ul>
        </Socials>
      </Content>
    </Container>
  );
}

export default Footer;
